import { render } from "./User.vue?vue&type=template&id=3f085868&scoped=true&ts=true"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=3f085868&lang=scss&scoped=true"
import "./User.vue?vue&type=style&index=1&id=3f085868&scoped=true&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f085868"]])

export default __exports__